define.alias("shared/components/shared/wizard/slide/header", "settings/components/shared/wizard/slide/header");